import React from 'react';
import { Url } from '@wix/da-url';
import { Trans, useTranslation } from 'react-i18next';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import TierConsumerReduxModule from '../../redux/consumer/ModuleLoadable';
import ConfirmationModal from '../../../Popup/ConfirmationModal';
import s from './UnsubscribeByUsernamePopup.scss';
export const UnsubscribePopup = ({ username, onUnsubscribe, close })=>{
    const { t } = useTranslation();
    const subscriptionsUrl = Url.userSubscriptionsPath({
        username
    });
    const content = /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviation.tier.unsubPopup.confirm.body.generic"
    }, "Bummer! Unsubscribing from this tier will mean losing out on these ", /*#__PURE__*/ React.createElement("a", {
        href: subscriptionsUrl
    }, "cool perks"), ".")));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ConfirmationModal, {
        isOpen: true,
        title: t('deviation.tier.unsubPopup.confirm.title'),
        text: content,
        icon: /*#__PURE__*/ React.createElement(Warning, null),
        confirmBtnType: "danger",
        confirmBtnLabel: t('deviation.tier.unsubPopup.confirm.accept'),
        cancelBtnLabel: t('deviation.tier.unsubPopup.confirm.cancel'),
        onCancel: close,
        onConfirm: ()=>{
            onUnsubscribe(username);
        }
    }), /*#__PURE__*/ React.createElement(TierConsumerReduxModule, null));
};
UnsubscribePopup.displayName = 'UnsubscribePopup';
export default UnsubscribePopup;

//# sourceMappingURL=UnsubscribeByUsernamePopup.js.map